var map = {
	"./certificate_image.png": 1322,
	"./complated.png": 1323,
	"./download_icon.png": 1324,
	"./facebook_icon.png": 680,
	"./linkedin_icon.png": 681,
	"./logo.png": 1325,
	"./pending.png": 1326,
	"./score_icon.png": 1327,
	"./training.png": 1328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1321;